import React, { useState } from "react";
import "./faqItem.css";

const FAQItem = (faqItem) => {
  const [answers, setAnswers] = useState(faqItem.answers.substring(0, 199));
  const [showMore, setShowMore] = useState(true);

  const showMoreOrLess = () => {
    setShowMore(!showMore);
    if (showMore) {
      setAnswers(faqItem.answers);
    } else {
      setAnswers(faqItem.answers.substring(0, 199));
    }
  };

  return (
    <div className="faq-item">
      <div className=" Actions space_between question-container">
        <h4 className="question">{faqItem.questions}</h4>
        <button
          type="button"
          className="link"
          onClick={() => {
            faqItem.setEditDetail({
              id: faqItem.id,
              answer: faqItem.answers,
              question: faqItem.questions,
              brandId: faqItem.brandId,
            });
            faqItem.setShowEditFAQ(true);
          }}
        >
          Edit
        </button>
      </div>
      <div className="answer">
        {faqItem.answers.length > 200 ? (
          <>
            <span
              dangerouslySetInnerHTML={{
                __html: answers.replace(/['"]+/g, ""),
              }}
            />
            <span>{" ..."}</span>
            <span>
              <button
                type="button"
                className="link"
                onClick={() => showMoreOrLess()}
              >
                {showMore ? "More" : "Less"}
              </button>
            </span>
          </>
        ) : (
          <span
          dangerouslySetInnerHTML={{
            __html: faqItem.answers.replace(/"/g, "").replace(/'/g, ""),
          }}          
          />
        )}
      </div>
    </div>
  );
};

export default FAQItem;
